import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RoomStep = ({ data, onUpdate, onNext }) => {
  const [selectedRoom, setSelectedRoom] = useState(data?.room || null);
  const [error, setError] = useState('');

  const rooms = [
  {
    id: 'cuisine',
    name: 'Cuisine',
    icon: 'Utensils',
    image: "https://images.unsplash.com/photo-1601760562234-9814eea6663a",
    imageAlt: 'Modern kitchen interior with stainless steel appliances and white cabinets',
    description: 'Évier, lave-vaisselle, robinetterie'
  },
  {
    id: 'salle-de-bains',
    name: 'Salle de bains',
    icon: 'Droplet',
    image: "https://images.unsplash.com/photo-1722604817198-276b04ebccea",
    imageAlt: 'Clean modern bathroom with white tiles, sink and mirror',
    description: 'Lavabo, douche, baignoire'
  },
  {
    id: 'wc',
    name: 'WC / Toilettes',
    icon: 'Home',
    image: "https://images.unsplash.com/photo-1723810779650-29f5b9856d67",
    imageAlt: 'Modern toilet room with white fixtures and clean design',
    description: 'Chasse d\'eau, cuvette, réservoir'
  },
  {
    id: 'buanderie',
    name: 'Buanderie',
    icon: 'Waves',
    image: "https://images.unsplash.com/photo-1723640584424-ac478a9d1443",
    imageAlt: 'Laundry room with washing machine and utility sink',
    description: 'Lave-linge, évier, tuyauterie'
  },
  {
    id: 'sous-sol',
    name: 'Sous-sol / Cave',
    icon: 'ArrowDown',
    image: "https://images.unsplash.com/photo-1702741566637-22bdf0bf52c0",
    imageAlt: 'Basement interior with exposed pipes and utility systems',
    description: 'Chaudière, tuyauterie, compteur'
  },
  {
    id: 'exterieur',
    name: 'Extérieur',
    icon: 'TreePine',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_15520e69c-1770369963689.png",
    imageAlt: 'Outdoor garden area with visible plumbing access points',
    description: 'Arrivée d\'eau, évacuation, robinet'
  },
  {
    id: 'autre',
    name: 'Autre pièce',
    icon: 'HelpCircle',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_14e49ed81-1770303792517.png",
    imageAlt: 'General home interior showing various rooms and spaces',
    description: 'Chambre, salon, autre espace'
  }];


  const handleRoomSelect = (room) => {
    setSelectedRoom(room);
    setError('');
  };

  const handleSubmit = () => {
    if (!selectedRoom) {
      setError('Veuillez sélectionner la pièce concernée');
      return;
    }

    onUpdate({ room: selectedRoom });
    onNext(true);
  };

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-card rounded-lg shadow-md p-6 lg:p-8">
        <div className="flex items-start gap-4 mb-8">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Home" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-foreground mb-2">Où se trouve le problème ?</h2>
            <p className="text-muted-foreground">
              Sélectionnez la pièce ou l'espace concerné par l'intervention
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {rooms?.map((room) =>
          <button
            key={room?.id}
            onClick={() => handleRoomSelect(room)}
            className={`group relative overflow-hidden rounded-lg border-2 transition-all duration-200 text-left ${
            selectedRoom?.id === room?.id ?
            'border-primary bg-primary/5 shadow-lg scale-105' :
            'border-border hover:border-primary/50 bg-card hover:shadow-md'}`
            }>
            
              <div className="aspect-video overflow-hidden">
                <Image
                src={room?.image}
                alt={room?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
              
              </div>
              <div className="p-4">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div
                    className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                    selectedRoom?.id === room?.id ? 'bg-primary/20' : 'bg-muted'}`
                    }>
                    
                      <Icon
                      name={room?.icon}
                      size={20}
                      color={selectedRoom?.id === room?.id ? 'var(--color-primary)' : 'currentColor'} />
                    
                    </div>
                    <h3 className="font-semibold text-foreground">{room?.name}</h3>
                  </div>
                  {selectedRoom?.id === room?.id &&
                <Icon name="CheckCircle" size={24} color="var(--color-primary)" />
                }
                </div>
                <p className="text-sm text-muted-foreground">{room?.description}</p>
              </div>
            </button>
          )}
        </div>

        {error &&
        <div className="mt-6 flex items-center gap-2 text-sm text-error bg-error/5 border border-error/20 rounded-lg p-4">
            <Icon name="AlertCircle" size={16} />
            <span>{error}</span>
          </div>
        }

        <div className="flex justify-end mt-8 pt-6 border-t border-border">
          <Button
            variant="default"
            size="lg"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={handleSubmit}>
            
            Continuer
          </Button>
        </div>
      </div>
    </div>);

};

export default RoomStep;